/*
 * Description: Form Actions Buttons Web Component
 * Purpose: Displays the standard Submit and Reset buttons for a form
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - Displays usual buttons in a form
 * 
 * Usage:
 * <form-action-buttons></form-action-buttons>
 * 
 * Attributes:
 * - None
 * 
 */

class form_action_buttons extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        this.innerHTML = `
                <input class="btn btn-primary" type="submit" value="Submit">
                <input class="btn btn-primary" type="reset" value="Reset">`;
        this.dataset.rendered = "true";
    }
}

export { form_action_buttons };
